import React, { useRef } from 'react'
/** @jsxImportSource @emotion/react */
import { css} from '@emotion/react'
import { Space,Table ,DatePicker,Pagination, Select, Input, Button} from 'antd';
import { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import MoneyOutlinedIcon from '@mui/icons-material/MoneyOutlined';
import CurrencyExchangeOutlinedIcon from '@mui/icons-material/CurrencyExchangeOutlined';

import axios from '../apiClient';
import Alert from '../alert';
import moment from 'moment/moment';
import { Tabs } from '@mui/material';

const {RangePicker} = DatePicker;

export default function TwoThreeSettle() {

  const [page,setPage] = useState(1);
  const [statements,setStatements] = useState([]);
  const [totalStatements, setTotalStatements] = useState();
  const [loading,setLoading] = useState(true)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const [searchName,setSearchName] = useState('');
  const [trnxType, setTrnxType] = useState("all");
  const [reports,setReports] = useState({})
  const [date,setDate] = useState({startDate: "",endDate: ""})
  const didMount = useRef(false);

  // New state for terms and settle functionality
  const [terms, setTerms] = useState([]);
  const [selectedTermId, setSelectedTermId] = useState(null);
  const [settleLoading, setSettleLoading] = useState(false);

  const trnxTypeOptions = ['all', 'deposit', 'withdraw']

  const navigate = useNavigate()

   useEffect(()=>{
    const today = moment();
    const startDate = moment(today).subtract(30, 'days').format('YYYY-MM-DD');
    const endDate = moment(today).format('YYYY-MM-DD');
    setDate({startDate: startDate,endDate: endDate})
   },[])

  // Fetch terms from API using axios
  async function fetchTerms() {
    try {
      let data = await axios.get(`/bet/getTerms?current=1&limit=1000`);
      if (data.code == 200 && data?.data&&data.data?.by) {
        setTerms(data.data.by);
      } else {
        setErrorMsg({ code: data.code || 'ERROR', msg: data.message || 'Failed to fetch terms' });
        setOpenAlert(true);
      }
    } catch (error) {
      console.error('Error fetching terms:', error);
      setErrorMsg({ code: 'ERROR', msg: 'Network error while fetching terms' });
      setOpenAlert(true);
    }
  }

  // Settle function using axios
  async function handleSettle() {
    if (!selectedTermId) {
      setErrorMsg({ info: true, msg: "Please select a term first!" });
      setOpenAlert(true);
      return;
    }

    setSettleLoading(true);
    try {
      let data = await axios.post(`https://api.kl36.bet/bet/settleLedger`, {
        termId: selectedTermId.toString()
      });

      // Show response message in alert
      setErrorMsg({ 
        info: data.code == 200, 
        msg: data.message
      });
      setOpenAlert(true);
      
    } catch (error) {
      console.error('Error during settlement:', error);
      setErrorMsg({ code: 'ERROR', msg: error.response?.data?.message || 'Network error during settlement' });
      setOpenAlert(true);
    } finally {
      setSettleLoading(false);
    }
  }

  // Load terms on component mount
  useEffect(() => {
    fetchTerms();
  }, []);

  async function fetchData() {
    // if(!searchName){
    //   setErrorMsg({ info: true, msg: "Need to input username!" })
    //   setOpenAlert(true)
    //   setLoading(false)
    //   return
    // }
    setLoading(true)
    let data = await axios.get(`/report/getStatementByMaster?type=${trnxType}&holderName=${searchName}&startDate=${date.startDate} 00:00:00&endDate=${date.endDate} 23:59:59&current=${page}&pageSize=10`)

    if (data.code != 200) {
        if(data.code == 404){
            setLoading(false)
            setStatements([])
            return
        }
        setErrorMsg({ code: data.code, msg: data.message })
        setOpenAlert(true)
        setLoading(false)
        return
    }
    setStatements(data.data.transactions);
    setReports(data?.data?.report);
    setTotalStatements(data.data.pagination.total);
    setLoading(false);
  }


  const handleCloseAlert = () => setOpenAlert(false)
  
  const handlePageChange = (page) => setPage(page)

  const handleTrnxTypeChange = (value) => setTrnxType(value);
  
  const handleSearchUsername = ({currentTarget}) => setSearchName(currentTarget.value);
  
  const handleDateChange = async (v,dateString) => setDate({startDate: dateString[0],endDate: dateString[1]});
  
  const handleTermChange = (value) => setSelectedTermId(value);
  
  useEffect(()=> {
    if(didMount.current){
      fetchData()
    }else{
      didMount.current = true;
    }
  },[trnxType,searchName,date,page])


    return (
      <div>
    <div>
       <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
       
       <div style={{display: 'flex', gap: '1rem', alignItems: 'center'}}>
          {/* Terms Dropdown */}
          <Select
            style={{width: "40%"}}
            onChange={handleTermChange}
            showSearch
            placeholder="Select Term"
            options={terms.map((term) => ({
              value: term.termId,
              label: `${term.termName}${term.winNum?` (${term.winNum})` : ''}`
            }))}
          />
          
          {/* Settle Button */}
          <Button 
            type="primary" 
            onClick={handleSettle}
            loading={settleLoading}
            disabled={!selectedTermId}
          >
            Settle
          </Button>
       </div>
    </div>
  </div>
  )
}
